import React from "react";

const { Provider, Consumer } = React.createContext<Record<number, any>>({});
export { Provider, Consumer };
